import { Link } from 'react-router-dom';
import ImagesData from '@assets/ImagesData';

const PageNotFound = () => {
  return (
    <div className='section page-not-found text-center'>
        <h2>Oops! Page not found.</h2>
        <p>It looks like the page you’re looking for has already checked out or never existed.</p>
        <img src={ImagesData?.ImgNotFound} />
        <div>
            <Link to="/" className="btn btn-primary">Homepage</Link>
        </div>
    </div>
  )
}

export default PageNotFound